import React from 'react'

const ChevronUpIcon = (props: any = {}) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10" fill="none">
            <path d="M1.99981 5.31787L5.18179 2.13589L8.36377 5.31787" stroke={props?.color ?? 'var(--primary)'} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}

export default ChevronUpIcon